export default __webpack_public_path__ + "static/media/bazzle_v_1.87ba755f.png";